import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {StepCarousel, Button, BUTTON_TYPE} from '@bepure/tarkin';

interface SectionProps {
    title: string;
    steps: Step[];
}

interface CarouselButton {
    text: string;
    link: string;
}

interface Step {
    pictureUrl: string;
    title?: string;
    subtitle?: string;
    description?: string;
    button?: CarouselButton;
}

class StepCarouselSection extends React.Component<SectionProps> {
    public render() {
        return (
            <StepCarousel
                title={this.props.title}
                steps={this.props.steps.map((step: Step) => {
                    return {
                        pictureUrl: step.pictureUrl,
                        htmlContent: (
                            <div className="step-carousel-kenobi">
                                <div className="text text--heading step_carousel_container__left_div__title">
                                    {step.title}
                                </div>
                                <h2 className="text text--heading--2 text--body--blue">{step.subtitle}</h2>
                                <div className="text text--body-2">{step.description}</div>
                                {
                                    (step.button && step.button.link && step.button.text) ?
                                    <Button
                                        otherClasses={'step-carousel-button'}
                                        ariaLabel={step.button.text}
                                        text={step.button.text}
                                        onClick={redirectOnClick(step.button.link)}
                                        button_type={BUTTON_TYPE.PRIMARY}
                                    /> : ''
                                }
                            </div>
                        ),
                    };
                })}
            />
        );
    }
}

const redirectOnClick = (link: string) => {
    return (event: React.MouseEvent<HTMLButtonElement>) => {
        window.location.assign(link);
    };
};

export default function render() {
    const elements = document.getElementsByClassName('steps-carousel-section');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const title = element.dataset.title ? element.dataset.title : '';
        const children = Array.prototype.slice.call(element.children)
        const steps = children.filter((child: HTMLElement) => child.dataset.imageurl).map((child: HTMLElement) => {
            const returnValue = {
                pictureUrl: child.dataset.imageurl || '',
                title: child.dataset.steptitle || '',
                subtitle: child.dataset.stepsubtitle || '',
                description: child.dataset.stepdescription || '',
                button: {
                    text: child.dataset.stepbuttontext ? child.dataset.stepbuttontext : '',
                    link: child.dataset.stepbuttonlink ? child.dataset.stepbuttonlink : '',
                },
            };
            return returnValue;
        });
        return ReactDOM.render(
            <StepCarouselSection title={title} steps={steps} />,
            element,
        );
    });
}
